// Checks if the current selection has a mark with `type` in it.
const hasMark = (value, type) => value.activeMarks.some(mark => mark.type === type);

export default hasMark;
